<template>
    <div v-if="!pending" :class="['container-fluid', pending ? 'd-none': '']" >
      <div class="row">
        <div class="col-12">
          <div class="table table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th colspan="7">
                  <div class="d-flex align-item-center justify-content-end">
                    <div class="align-self-center">
                      <b-form-checkbox v-model="onlyOn" switch size="sm" v-on:input="onlyOnChange">
                        <i :class="['fas fa-fire-alt', onlyOn ? 'text-primary' : 'text-secondary']"></i>
                      </b-form-checkbox>
                    </div>
                    <div class="align-self-center">
                      <b-form-checkbox v-model="filterOnlyMe" switch size="sm" v-on:input="filterOnlyMeChange">
                        <i :class="['far', filterOnlyMe ? 'fa-kiss-wink-heart text-primary' : 'fa-meh']"></i>
                      </b-form-checkbox>
                    </div>
                    <div class="align-self-center">
                      <b-form-select
                        v-model="perPage"
                        :options="options"
                        size="sm"
                        @change="load(1)"
                      >
                      </b-form-select>
                    </div>
                  </div>
                </th>
              </tr>
              <tr role="row" class="bg-light">
                <th v-for="header in headers" v-bind:key="`th-${header.label}`"  :style="{'width': `${header.width}%`}" :class="[header.cls]">
                  {{header.label}}
                </th>
              </tr>
              </thead>
              <tbody v-if="rows">
              <projectSpecific
                v-for="(project, idx) in projectList"
                v-bind:key="idx"
                :info="project"
                :statusList="statusList"
                :surveyID="surveyID"
                :class="{'bg-info': project._id === insertedId, 'text-white': project._id === insertedId}"
              ></projectSpecific>
              </tbody>
              <tbody v-else>
                <tr>
                  <th :colspan="headers.length">NO DATA</th>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <b-form class="my-3" inline @submit.stop.prevent>
              <b-form-group class="ml-auto mr-1">
                <b-form-select
                  v-model="filterField"
                  size="sm"
                  :options="filterFields"
                  v-on:change="filterValue = ''"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group class="mr-1">
                <b-form-select
                  v-if="filterField.toLowerCase() ==='status'"
                  size="sm"
                  v-model="filterValue"
                  :options="statusListOption"
                >
                </b-form-select>
                <b-input
                  v-else
                  type="text"
                  v-model="filterValue"
                  v-on:keyup.enter="search()"
                  size="sm"
                  placeholder="value"
                ></b-input>
              </b-form-group>
              <b-form-group>
                <b-button size="sm" variant="danger" :disabled="!filterField.length"  v-on:click="search()">Filter</b-button>
              </b-form-group>
            </b-form>
          </div>
          <div
            v-if="rows"
            class="text-center w-100"
          >
            <b-pagination-nav
              v-model="currentPage"
              :link-gen="linkGen"
              :number-of-pages="numberOfPages"
              use-router
              align="center"
            />
<!--            <b-pagination-->
<!--              v-model="currentPage"-->
<!--              :total-rows="rows"-->
<!--              :per-page="perPage"-->
<!--              aria-controls="my-table"-->
<!--              align="center"-->
<!--              @input="load"-->
<!--            ></b-pagination>-->
          </div>
        </div>
      </div>
    </div>
    <Pending v-else></Pending>
</template>
<script>
const projectSpecific = () => import('./projectSpecificNew')
export default {
  name: 'projectList',
  components: {
    projectSpecific
  },
  props: {
    insertedId: String,
    surveyID: String
  },
  data: () => ({
    pending: false,
    currentPage: 1,
    perPage: 10,
    rows: 0,
    searchTimeout: null,
    projectList: [],
    filterField: '',
    filterValue: '',
    filterFields: [],
    metaData: null,
    statusList: {},
    statusListOption: [],
    headers: [
      {label: 'No', width: 7.5, cls: 'd-none d-md-table-cell'},
      {label: 'Sub No', width: 7.5, cls: 'd-none d-md-table-cell'},
      {label: 'Name', width: 30},
      {label: 'Progress', width: 20, cls: 'd-none d-md-table-cell'},
      {label: 'Period', width: 20},
      {label: 'Status', width: 5},
      {label: 'Manager', width: 10}
    ],
    options: [
      {value: 10, text: '10 per page'},
      {value: 20, text: '20 per page'},
      {value: 30, text: '30 per page'}
    ],
    filterOnlyMe: false,
    onlyOn: false
  }),
  created () {
    (async () => {
      if (this.$store.getters) {
        const {projectListOnlyMe, projectOnlyOn} = this.$store.getters
        this.filterOnlyMe = projectListOnlyMe
        this.onlyOn = projectOnlyOn
      }
      const { query } = this.$route
      if (query) {
        const { page, filterField, filterValue } = query
        if (page && !isNaN(+page)) this.currentPage = +page
        if (filterField) this.filterField = filterField
        if (filterValue) this.filterValue = filterValue
      }
      await this.load()
    })()
  },
  methods: {
    linkGen (pageNum) {
      const params = {
        page: pageNum,
        filterField: this.filterField,
        filterValue: this.filterValue
      }
      if (!this.filterField) delete params.filterField
      if (!this.filterValue) delete params.filterValue
      const query = Object.entries(params).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')
      return `?${query}`
    },
    async load (page) {
      this.pending = true
      try {
        const url = `/project/list/${page || this.currentPage}`
        const method = 'get'
        const params = {
          perPage: this.perPage,
          field: this.filterField,
          value: this.filterValue
        }
        if (this.filterOnlyMe) params.filterOnlyMe = true
        if (this.onlyOn) params.onlyOn = true
        const {data} = await this.axios({
          url,
          method,
          params
        })
        const {filterField, projectList, rows, perPage, statusList, field, value} = data
        this.projectList = projectList
        this.rows = rows
        this.perPage = perPage
        this.statusList = statusList
        const enums = this.statusList.enums
        this.statusListOption = this.statusList.list.map(l => {
          return {text: l, value: enums[l]}
        })
        if (filterField) this.filterFields = [{ value: '', text: 'Select a filter' }, ...filterField]
        if (field) this.filterField = field
        if (value) this.filterValue = value
      } catch (e) {}
      this.pending = false
    },
    async search () {
      this.currentPage = 1
      const query = {
        page: this.currentPage,
        filterField: this.filterField,
        filterValue: this.filterValue
      }
      try {
        await this.$router.push({ query })
      } catch (e) {
        console.log(e)
      }
    },
    onlyOnChange () {
      this.$store.dispatch('projectOnlyOn', this.onlyOn).then(() => {
        if (this.onlyOn) {
          this.filterField = 'status'
          this.filterValue = this.statusList.enums['ON']
          this.search(1)
        } else {
          this.filterField = ''
          this.filterValue = ''
          this.load(1)
        }
      })
    },
    filterOnlyMeChange () {
      this.$store.dispatch('projectListOnlyMe', this.filterOnlyMe).then(() => {
        this.load()
      })
    }
  },
  computed: {
    numberOfPages () {
      return this.rows === 0 ? 1 : Math.ceil(this.rows / this.perPage)
    }
  },
  watch: {
    filterOnlyMe (value) {

    },
    onlyOn (value) {

    }
  }
}
</script>

<style scoped>
  table.table > tbody {
    font-size: 0.8rem;
  }
  table.table > tbody > tr > td {
    padding: 1px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/project/list/subComponents/projectList.vue